<style>
	.bg {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw;}
.tabbar2{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;  }
.tabbar2 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar2 span.pos{ padding:0 1vw;}
.tabbar2 span.floder{ color:#666;}
 
.tabbar2 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;} 
  


.sj_list{width:84vw;margin-left:7vw;margin-top:1vw;height:8vw;border:#e5e5e5 solid 1px;}
.sj_left{width:40vw;height:100%; position:relative;float:left;}
.sj_left input{ width: 1.4vw;height:1.4vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;position:absolute;left:1vw;top:1vw;}
.sj_left img{display:block;position:absolute;top:1vw;left:3vw;width:2vw;}
.sj_left_title{width:50vw;height:2vw;position:absolute;left:5vw;top:1vw;}
.sj_left_title span{display:block;float:left;line-height:2vw;}
.sj_left_title span.t1{font-size:1.2vw;color:#0F7A3E;}
.sj_left_title span.t2{font-size:1vw;padding-left:.5vw;color:#999;}
.sj_left span.fl{position:absolute;display:block;top:3.5vw;left:5vw;font-size:1vw;color:#999;border:#ddd solid 1px;height:2vw;line-height:2vw;padding:0 .5vw;
    border-radius:.5vw;}
	
.sj_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1vw;
 color:#333;}
 
.sj_right{width:14vw;height:100%; float:right;box-sizing:border-box;}
.sj_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:12vw;padding:0 1vw;font-size:1vw;
 color:#333;}
.sj_right span.mn2{color:#0F7A3E;}
.sj_right span.mn3{color:#f00;}
.sj_fresh{width:10vw;height:100%;border-left:#ddd solid 1px;box-sizing:border-box;float:right;}
.sj_fresh img{display:block;margin:0 auto;width:2.5vw;margin-top:2vw;}
.sj_fresh span{display:block;width:100%;text-align:center;line-height:3vw;color:#3465ff;font-size:1vw;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits6{width:22vw;height:4vw;border-radius:.5vw;float:right; }
.submits6 button{outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:10vw;color:#fff;border-radius:.5vw;float:right;}
.submits6 button.ck{outline:none;border:#ddd solid 1px;font-size:1.2vw;display:block;height:4vw;line-height:4vw; color:#333;border-radius:.5vw;background:none;
float:left;}
.submits6 button.zong{background:#3268ff;}
.send_result2{margin-top:1vw;}




.rs_head{width:84vw;margin-left:7vw;margin-top:8vw;border:#3465ff solid 2px;height:4vw;border-top-left-radius:.5vw;border-top-right-radius:.5vw;
box-sizing:border-box; position:relative;z-index:9;}
.rs_head span{display:block;float:left;height:4vw;line-height:4vw;font-size:1.1vw;text-align:center;}
.rs_head span.sai{display:block;float:left;height:3.9vw;background:#3465ff;width:15vw;color:#fff;position:absolute;left:0;top:0;z-index:9;}
.rs_head ul.xx{position:absolute;left:15vw;top:0;}
.rs_head ul.xx li{float:left;width:22.9vw;position:relative;margin:0;padding:0;overflow:hidden;height:4vw;cursor:pointer;}
.rs_head ul.xx li span.val{width:20vw;position:absolute;}
.rs_head ul.xx li img{position:absolute;top:1.2vw;width:1.5vw;right:1vw;}
.rs_head ul.xx li span.border{width:1px;height:2vw;border-right:#ddd soliid 1px;position:absolute;right:0;top:1vw;}
.quan{width:84vw;margin-left:7vw;background:#f9f9f9;height:4vw;}
.quan input{ width: 1.4vw;height:1.4vw;float:left;margin-left:1vw;margin-top:1.3vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;}
.quan span.qx{display:block;float:left;line-height:4vw;font-size:1.1vw;padding-left:.5vw;}
.add_sj{width:8vw;height:2.4vw;border:#3465ff solid 1px;margin-top:.8vw;;float:right;margin-right:1vw;border-radius:.5vw;}
.add_sj img{display:block;float:left;width:1.4vw;margin-top:.5vw;margin-left:.5vw;}
.add_sj span{display:block;float:right;width:6.1vw;text-align:center;line-height:2.4vw;font-size:1vw;color:#3465ff;}


.sj_list{width:84vw;margin-left:7vw;margin-top:1vw;height:8vw;border:#e5e5e5 solid 1px;}
.sj_left{width:50vw;height:100%; position:relative;float:left;}
.sj_left input{ width: 1.4vw;height:1.4vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;position:absolute;left:1vw;top:1vw;}
.sj_left img{display:block;position:absolute;top:1vw;left:3vw;width:2vw;}
.sj_left_title{width:50vw;height:2vw;position:absolute;left:5vw;top:1vw;}
.sj_left_title span{display:block;float:left;line-height:2vw;}
.sj_left_title span.t1{font-size:1.2vw;color:#0F7A3E;}
.sj_left_title span.t2{font-size:1vw;padding-left:.5vw;color:#999;}
.sj_left span.fl{position:absolute;display:block;top:3.5vw;left:5vw;font-size:1vw;color:#999;border:#ddd solid 1px;height:2vw;line-height:2vw;padding:0 .5vw;
    border-radius:.5vw;}
	
.sj_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1vw;
 color:#333;}
 
.sj_right{width:14vw;height:100%; float:right;box-sizing:border-box;}
.sj_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:12vw;padding:0 1vw;font-size:1vw;
 color:#333;}
.sj_right span.mn2{color:#0F7A3E;}
.sj_right span.mn3{color:#f00;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits2{width:12vw;height:4vw;border-radius:.5vw;float:right;background:#ccc;}
.submits2 button{background:#3268ff;outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:100%;color:#fff;border-radius:.5vw;}


.xiala{position:absolute;top:3.8vw;background:#fff;width:22.9vw;left:15vw;border:#ddd solid 1px;border-top:0;z-index:999999;box-sizing:border-box;
      max-height:30vw;  overflow-x: hidden;}
.xiala ul li{width:100%;height:3vw;line-height:3vw;text-align:center;border-bottom:#666 dotted 1px;box-sizing:border-box;font-size:1.1vw;
  cursor:pointer;}
.xiala ul li:last-child{border-bottom:0;}

 
.xiala2{left:38vw;}
 
.xiala3{left:61vw;}
 
.sc_box{width:100%;height:2vw;background:#f6f6f6;position:absolute;bottom:0;}
.sc_box span{display:block;float:left;line-height:2vw;font-size:1vw;margin-left:5vw;}

.submits22{width:12vw;height:4vw;margin:0 auto;background:#fff;border:#ddd solid 1px;margin-top:0;border-radius:.5vw;}
.submits22 span{display:block;float:left;width:6vw;text-align:center;color:#999;font-size:1.4vw;line-height:4vw;}
.submits22 img{display:block;float:left;width:2vw;margin-top:1vw;height:2vw;margin-left:1.5vw;}

</style>
 
<template>
	<div class="bg">
	      

		
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img src="../../assets/images/home_icon.png">
			<div class="tabbar2">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送短信通知</span>
			   <span class="rights"></span>
			   <span class="floder">选择短信模板</span>
			   <span class="rights"></span>
			   <span class="floder">导入数据表</span>
			   <span class="rights"></span>
			   <span class="floder">选择数据表关键信息</span>
			</div>
		 </div>
		  
		  
		  <div class="rs_head">
		    <span class="sai">筛选数据表</span>
			<ul class="xx">
			   <li @click="xiala(1)"><span class="val">{{leibie}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(2)"><span class="val">{{date}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(3)" style="border-right:0;"><span class="val">{{chart_type}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   
			</ul>

               <transition name="draw">
				   <div class="xiala" v-show="xiala1">
					  <ul>
						 <li v-for="item in leibie_list" @click="select_year(item.year)">{{item.zhao}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xiala xiala2" v-show="xiala2">
					  <ul>
						 <li v-for="item in date_list" @click="select_zhao(item.zhao)">{{item.pi}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xiala xiala3" v-show="xiala3">
					  <ul>
						 <li v-for="item in chart_list" @click="select_pi(item.pi)">{{item.lei}}</li>
					  </ul>
				   </div>
			   </transition>
			    
			   
		 </div>
		  
		  
		  
		 <div class="send_result2">  
		 <div class="sj_list " v-for="item in list">
             <div class="sj_left">
			    <input type="checkbox" @click="check(item.id,0)" v-if="item.on==1" checked>
				<input type="checkbox" @click="check(item.id,1)" v-else>
				<img src="../../assets/images/excel.png">
				<div class="sj_left_title">
					<span class="t1">{{item.title}}</span>
					<span class="t2">{{item.date}}</span>
				</div>
				<span class="fl">2021年-统招-普通类-四川省-录取名单</span>
				<div class="sc_box">
				  <span>上传日期：2021-11-12</span>
				  <span>发送日期：2021-11-12</span>
				</div>
			 </div>
			 <div class="sj_fresh">
			    <img src="../../assets/images/fresh.svg">
				<span>刷新数据</span>
			 </div>
             <div class="sj_right">
			      <span class="mn1">7077</span>
				  <span class="mn2">7000</span>
				  <span class="mn3" style="border-bottom:0;">7</span>
			 </div>
			 <div class="sj_middle">
			      <span class="m1">总数据条数</span>
				  <span class="m2">导入成功</span>
				  <span class="m3" style="border-bottom:0;">导入失败</span>
			 </div>
         </div>
         </div>	 
         <div class="pages">
		    <div class="pre">
			   <img src="../../assets/images/pre1.png">
			</div>
			<div class="next">
			   <img src="../../assets/images/next1.png">
			</div>
		 </div>
		  <div class="submits22">
		      <img src="../../assets/images/pre2.svg">
		     <span>上一步</span>
			 
		 </div> 
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		  Progress
	    },
		data() {
			return {
				 list:[{id:1,title:"清华大学统招专科批普通类录取名单.xls",date:"2021-12-11",cate:"2021年-统招-普通类-四川省-录取名单",on:0},
				       {id:2,title:"清华大学统招专科批普通类录取名单.xls",date:"2021-12-11",cate:"2021年-统招-普通类-四川省-录取名单",on:0},
					   {id:3,title:"清华大学统招专科批普通类录取名单.xls",date:"2021-12-11",cate:"2021年-统招-普通类-四川省-录取名单",on:0},
					   {id:4,title:"清华大学统招专科批普通类录取名单.xls",date:"2021-12-11",cate:"2021年-统招-普通类-四川省-录取名单",on:0}],			   
				 all_check:false,
				 xiala1:false,
				 xiala2:false,
				 xiala3:false,

				 leibie:"短信类别",
				 leibie_list:[{id:1,zhao:'统招'},{id:2,zhao:'单招'}],
				 date:'发送日期',
				 date_list:[{id:1,pi:'本科批'},{id:2,pi:'专科批'}],
				 chart_type:"数据表类别",
				 chart_list:[{id:1,lei:'普通类'},{id:2,lei:'财经类'},{id:3,lei:'艺术类'},{id:4,lei:'计算机类'}],
				  
				 progress_show:true,
				 onkey_show:false,
				 safe_show:false,
				 mode:2
			}
		},
		mounted() {
		    let self=this;
		    
		 
			
		},
		methods: {
		    check(id,val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].on=val;
					} 
				});
			    this.list=new_list;
				console.log(this.list)
			},all(val){
			    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].on=val; 
				});
			    this.list=new_list;
			},xiala(id){
			  if(id==1){
			     this.xiala1=!this.xiala1;this.xiala2=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==2){
			     this.xiala2=!this.xiala2;this.xiala1=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==3){
			     this.xiala3=!this.xiala3;this.xiala1=false;this.xiala2=false;this.xiala4=false;this.xiala5=false;
			  } 
			},select_year(year){
			  this.year=year;
			  this.xiala1=false;
			},select_zhao(zhao){
			  this.leibie=zhao;
			  this.xiala2=false;
			},select_pi(pi){
			  this.pici=pi;
			  this.xiala3=false;
			} 
		     
		},watch:{
			 all_check(){
			   if(this.all_check==true){
			     this.all(1)
			   }else{
			     this.all(0)
			   }
			 }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/fail_list.vue